"use client"

import { useQuery } from "@tanstack/react-query"
import type React from "react"
import {
	ResponsiveDialog,
	ResponsiveDialogContent,
	ResponsiveDialogHeader,
	ResponsiveDialogTitle,
	ResponsiveDialogTrigger,
} from "@/components/ui/responsive-dialog"
import {
	getCurrentAreaInClient,
	getCurrentLangInClient,
} from "@/lib/utils.client"
import { useORPC } from "@/providers/orpc-provider"
import { CMSRichText, CMSText } from "./components/cms-items"
import type { CMSRule } from "./schema"

interface RuleModalProps {
	slug: string
	children: React.ReactNode
	title?: string
	showOverlay?: boolean
}

export function RuleModal({
	slug,
	children,
	// title,
	showOverlay = true,
}: RuleModalProps) {
	const area = getCurrentAreaInClient()
	const lang = getCurrentLangInClient()
	const orpc = useORPC()

	const { data: ruleDataResponse, isLoading } = useQuery({
		...orpc.cms.content.public_findLiveWithPagination.queryOptions({
			input: {
				parentAlias: "footer-rules",
				type: slug,
				area: area?.toUpperCase(),
				platform: "web",
			},
		}),
		enabled: !!slug && !!area && !!lang,
		staleTime: 60 * 60 * 1000,
	})

	const ruleData = ruleDataResponse?.items[0] as unknown as CMSRule

	return (
		<ResponsiveDialog modal={showOverlay}>
			<ResponsiveDialogTrigger asChild>{children}</ResponsiveDialogTrigger>
			<ResponsiveDialogContent className="max-w-2xl max-h-[80vh] overflow-hidden flex flex-col z-99999">
				<ResponsiveDialogHeader className="sticky top-0 bg-transparent">
					<ResponsiveDialogTitle className="  ">
						<CMSText text={ruleData?.title_trans} />
					</ResponsiveDialogTitle>
				</ResponsiveDialogHeader>
				<div
					className="overflow-y-auto overflow-x-hidden"
					onWheel={(e) => e.stopPropagation()}
				>
					{isLoading ? (
						<div className="py-8 text-center">加载中...</div>
					) : (ruleData?.data as any)?.content_trans ||
						ruleData?.data?.content ? (
						<div className="article-content article-content-inner">
							<CMSRichText
								text={
									(ruleData?.data as any)?.content_trans ||
									ruleData.data?.content
								}
							/>
						</div>
					) : (
						<p className="text-center text-gray-500 py-4">暂无详细规则内容。</p>
					)}
				</div>
			</ResponsiveDialogContent>
		</ResponsiveDialog>
	)
}
